<app-shell [title]="title()">
  @if (isOutlet) {
    <router-outlet />
  } @else {
    <div>Loading...</div>
  }
</app-shell>
